/* MAC "Empty basket" (preview). Delegated handlers: open the inline confirm, Cancel closes it, confirm POSTs
   /cart/clear.js then reloads the cart page, or re-renders the drawer + count (drawer stays as it is; never auto-opens). */
(function(){
  'use strict';
  if (window.MacEmptyBasket) return; window.MacEmptyBasket = true;
  function box(el){ return el && el.closest('[data-mac-eb]'); }
  function panel(b){ return b.querySelector('.mac-eb__confirm'); }
  function toggle(b, open){
    var p = panel(b), o = b.querySelector('[data-mac-eb-open]'); if (!p || !o) return;
    p.hidden = !open; o.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var n = p.querySelector('[data-mac-eb-no]'); if (n) n.focus({ preventScroll: true }); if (p.scrollIntoView) p.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } else { o.focus({ preventScroll: true }); }
  }
  function refreshDrawer(){
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
    /* also update any count badges directly in case the theme only re-renders on its own events */
    /* the header "Shop / N" count (snippets/cart.liquid) is server-rendered only, so set it here */
    document.querySelectorAll('.cart-count-text').forEach(function(e){ e.textContent = '0'; });
    document.querySelectorAll('.custom-cart-btn[aria-label]').forEach(function(e){ e.setAttribute('aria-label', '0'); });
  }
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-mac-eb-open],[data-mac-eb-no],[data-mac-eb-yes]'); if (!t) return;
    var b = box(t); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (t.hasAttribute('data-mac-eb-open')) { toggle(b, panel(b).hidden); return; }
    if (t.hasAttribute('data-mac-eb-no')) { toggle(b, false); return; }
    var msg = b.querySelector('.mac-eb__msg'); t.disabled = true; t.textContent = 'Emptying\u2026';
    fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function(r){ if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function(){
        document.dispatchEvent(new CustomEvent('mac:basketemptied', { bubbles: true, detail: { where: b.getAttribute('data-mac-eb-where') } }));
        if (b.getAttribute('data-mac-eb-where') === 'page' || /^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        refreshDrawer();
      })['catch'](function(){
        t.disabled = false; t.textContent = 'Empty basket';
        if (msg) msg.textContent = 'Sorry, the basket could not be emptied. Please try again.';
      });
  }, true);
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return; var b = box(document.activeElement);
    if (b && !panel(b).hidden) { e.stopPropagation(); toggle(b, false); }
  }, true);
})();
